import { ConnectedFocusError } from "focus-formik-error"
import { Form, Formik, FormikHelpers, FormikProps } from "formik"
import { ReactNode, Ref, useState } from "react"

type CommonFormProps<Schema, Values> = {
  validationSchema: Schema
  initialValues: Values
  render(props: FormikProps<Values>): ReactNode
  onSubmit(values: Values, actions: FormikHelpers<Values>): Promise<void>
  innerRef?: Ref<FormikProps<Values>>
  validate?: (values: Values) => void
  alwaysValidate?: boolean
}

function FormikForm<Schema, Values>({
  validationSchema,
  initialValues,
  render,
  onSubmit,
  validate,
  innerRef,
  alwaysValidate,
}: CommonFormProps<Schema, Values>) {
  const [formIsDirty, setFormIsDirty] = useState(false)
  return (
    <Formik
      validate={validate}
      innerRef={innerRef}
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount={false}
      validateOnChange={alwaysValidate || formIsDirty}
      validateOnBlur={alwaysValidate || formIsDirty}
      onSubmit={async (values, actions) => {
        actions.setSubmitting(true)
        await onSubmit(values, actions)
        actions.setSubmitting(false)
      }}
      enableReinitialize
    >
      {(formik) => {
        return (
          <Form
            noValidate
            onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
              e.preventDefault()
              setFormIsDirty(true) // changes formkit.validateOnChange state to true
              return formik.handleSubmit()
            }}
          >
            <ConnectedFocusError />
            {render(formik)}
          </Form>
        )
      }}
    </Formik>
  )
}

export default FormikForm
